import { Helmet } from "react-helmet"
import { useParams } from "react-router-dom"

import { useTheme } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import Grid from "@mui/material/Grid"

import { AuthContainer, AuthSection, Heading, SubHeading } from "@/auth/StyledComponents"
import { GlobalStyle } from "@/themes"
import { InternalLink, MakeOSIcon, PageTitle } from "@/common/CommonComponents"

export default function Verify() {
    const theme = useTheme()
    const params = useParams()
    const status = params["*"]

    const hasError = Boolean(status)
    let heading = "Verify Your Account"
    let subHeading = "To complete your registration, please check your inbox for a verification email."
    if (status) {
        if (status.includes("error")) {
            heading = "Sorry, we could not verify your account"
            subHeading = "The link you used is invalid or expired. To trigger a new email verification, please try logging in again."
        } else {
            heading = "Account Verification Required"
            subHeading = "To complete your registration, please check your inbox for a verification email. To trigger a new email verification, please try logging in again."
        }
    }
    
    const themeMode = localStorage.getItem("themeMode") || "light"
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    
    return (
        <AuthContainer isMobile={isMobile}>
            <Helmet><PageTitle title="Verify Account" /></Helmet>
            <GlobalStyle theme={themeMode} />            

            <AuthSection isMobile={isMobile}>
                {!isMobile && <MakeOSIcon position="topLeft" />}
    
                <Grid item container direction="column" spacing={2}>
                    <Grid item sx={{marginBottom: isMobile ? "24px" : "48px"}}> 
                        <MakeOSIcon width={222} />
                    </Grid>
                    <Grid item>
                        <Heading>{heading}</Heading>
                    </Grid>
                    <Grid item>
                        <SubHeading>{subHeading}</SubHeading>
                    </Grid>
                    {hasError && (
                        <Grid item>
                            <InternalLink href="/login">
                                <SubHeading>Log In</SubHeading>
                            </InternalLink>
                        </Grid>
                    )}
                </Grid>
            </AuthSection>
        </AuthContainer>
    )
}
